module.exports = __webpack_public_path__ + "assets/img/1605_07.jpg?7e3073bfe4f8c6b55875e32b707e4541";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/1605_07.jpg
// module id = 1110
// module chunks = 0